import "./SiteEquipment.html";
import "./SiteEquipment.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteEquipmentComponentController from "./SiteEquipmentComponentController";

export default class SiteEquipmentComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SiteEquipmentComponentController;
        this.templateUrl = "/App/Components/Site/Equipment/SiteEquipment.html";
    }
}

module("mmManagePortal").component("irSiteEquipment", new SiteEquipmentComponent());
